import { render, staticRenderFns } from "./Viewproducts.vue?vue&type=template&id=5b98a99c&"
import script from "./Viewproducts.vue?vue&type=script&lang=js&"
export * from "./Viewproducts.vue?vue&type=script&lang=js&"
import style0 from "./Viewproducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports